// InputArea.js
import React, { useState } from 'react';

function InputArea({ onSend }) {
  const [inputText, setInputText] = useState('');

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };

  const handleSendClick = () => {
    if (inputText.trim()) {
      onSend(inputText);
      setInputText('');
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && inputText.trim()) {
      onSend(inputText);
      setInputText('');
    }
  };

  return (
    <div className="input-area">
      <input
        type="text"
        value={inputText}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        placeholder="Type a message..."
      />
      <button onClick={handleSendClick}>Send</button>
    </div>
  );
}

export default InputArea;

